import type { LngLat } from "./types.ts";

export function isValidLngLat([lng, lat]: LngLat): boolean {
  return Number.isFinite(lng) && lng >= -180 && lng <= 180 &&
    Number.isFinite(lat) && lat >= -90 && lat <= 90;
}
